<app-modal *ngIf="vo$ | async; let vo">
	<div
		modal-body
		class="app-column-model-confirm-popup">
		<ng-container [ngSwitch]="vo.action">
			<ng-container *ngSwitchCase="ColumnModelAction.Delete">
				<!-- alert info -->
				<dc-alert
					*ngIf="!vo.isMultipleElement" type="error" message="info"
					i18n-message="@@subscription.columnModel.action.confirm.popup.delete.info"></dc-alert>

				<dc-alert
					*ngIf="vo.isMultipleElement" type="error" message="multiple-info"
					i18n-message="@@subscription.columnModel.action.confirm.popup.delete.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-column-model-confirm-popup__description"
					i18n="@@subscription.columnModel.action.confirm.popup.delete.description">
						deletion-request</span>
				<span
					*ngIf="vo.isMultipleElement"
					class="app-column-model-confirm-popup__description"
					i18n="@@subscription.columnModel.action.confirm.popup.delete.multiple.description">
					deletion-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="ColumnModelAction.Update">
				<!-- alert info -->
				<dc-alert
					type="warning" message="warn"
					i18n-message="@@subscription.columnModel.action.confirm.popup.update.info"></dc-alert>

				<!-- description request -->
				<span
					class="app-column-model-confirm-popup__description"
					i18n="@@subscription.columnModel.action.confirm.popup.update.description">
					update-request</span>
			</ng-container>
		</ng-container>

		<div class="app-column-model-confirm-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span
					i18n="@@subscription.action.confirmation.popup.concernedElement">
					concerned-element</span>

				<span class="app-column-model-confirm-popup__element-label">
					{{ vo.element | truncate: 30: 1 : 'end' }}</span>
			</ng-container>

			<ng-container *ngIf="vo.isMultipleElement">
				<span
					i18n="@@subscription.action.confirmation.popup.concernedElements">
					concerned-elements</span>

				<div class="app-column-model-confirm-popup__element-label">
					{{ vo.columnModelId.length }}
					<span
						i18n="@@subscription.columnModel.action.confirm.popup.columnModels">
						column-models</span>
				</div>
			</ng-container>
		</div>

		<mat-checkbox
			id="{{ cmpId }}-confirm-delete-checkbox"
			color="primary"
			[(ngModel)]="confirm">
			<span
				*ngIf="vo.action === ColumnModelAction.Delete"
				i18n="@@subscription.action.confirmation.popup.delete.confirm">
				confirm-delete</span>
			<span
				*ngIf="vo.action === ColumnModelAction.Update"
				i18n="@@subscription.action.confirmation.popup.update.confirm">
				confirm-update</span>
		</mat-checkbox>
	</div>

	<div modal-footer  class="app-column-model-confirm-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="ColumnModelAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-column-model-confirm-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirm"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.delete.btn">
					delete
				</span>
			</button>

			<button
				*ngSwitchCase="ColumnModelAction.Update"
				id="{{ cmpId }}-update-btn"
				class="app-column-model-confirm-popup__footer__btn"
				[color]="'primary'"
				[disabled]="!confirm"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Edit"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.update.btn">
					update</span>
			</button>
		</ng-container>
	</div>
</app-modal>
